import { Link } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'

function Breadcrumb({ items }) {
    const { theme } = useTheme()

    return (
        <nav className="breadcrumb flex items-center space-x-2 text-sm mb-4">
            {items.map((item, i) => (
                <span key={i} className="flex items-center space-x-2">
                    {i > 0 && (
                        <svg className={`w-4 h-4 ${theme === 'dark' ? 'text-gray-600' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    )}
                    {item.path ? (
                        <Link to={item.path}>{item.label}</Link>
                    ) : (
                        <span className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>{item.label}</span>
                    )}
                </span>
            ))}
        </nav>
    )
}

export default Breadcrumb
